"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorReporter = void 0;
var react_1 = __importDefault(require("react"));
var ErrorListContext_1 = require("../ErrorListContext");
/**
 * Reports an error to a containing ErrorList React Context.
 * Note that the error will remain in the ErrorList while this component remains in the tree.
 */
var ErrorReporter = /** @class */ (function (_super) {
    __extends(ErrorReporter, _super);
    function ErrorReporter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ErrorReporter.prototype.render = function () {
        var _this = this;
        return (react_1.default.createElement(ErrorListContext_1.ErrorListContext.Consumer, null, function (errorList) { return (react_1.default.createElement(ErrorReporterInternal, { errorCode: _this.props.errorCode, errorMessage: _this.props.errorMessage, errorList: errorList })); }));
    };
    return ErrorReporter;
}(react_1.default.Component));
exports.ErrorReporter = ErrorReporter;
var ErrorReporterInternal = /** @class */ (function (_super) {
    __extends(ErrorReporterInternal, _super);
    function ErrorReporterInternal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.errorId = null;
        return _this;
    }
    ErrorReporterInternal.prototype.componentDidMount = function () {
        this.reportError();
    };
    ErrorReporterInternal.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.errorCode !== prevProps.errorCode ||
            this.props.errorMessage !== prevProps.errorMessage) {
            this.reportError();
        }
    };
    ErrorReporterInternal.prototype.componentWillUnmount = function () {
        this.removeError();
    };
    ErrorReporterInternal.prototype.render = function () {
        return null;
    };
    ErrorReporterInternal.prototype.reportError = function () {
        this.removeError();
        this.errorId = this.props.errorList.addError(this.props);
    };
    ErrorReporterInternal.prototype.removeError = function () {
        if (this.errorId != null) {
            this.props.errorList.removeError(this.errorId);
            this.errorId = null;
        }
    };
    return ErrorReporterInternal;
}(react_1.default.Component));
//# sourceMappingURL=ErrorReporter.js.map